import gql from 'graphql-tag'

export default gql`
	mutation exportMirus {
		cashAssist {
			exportMirus {
				key
				url
				bucket
			}
		}
	}
`
